import { MenuItem } from '@v2/shared/lib/types';
import {
  faReceipt as fasReceipt,
  faUserCircle as fasUserCircle,
  faHouseChimney as fasHouseChimney,
  faLock as fasLock,
  faBookOpen as fasBookOpen,
  faBell as fasBell,
  faHeart as fasHeart,
} from '@fortawesome/pro-solid-svg-icons';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import { faCardsBlank } from '@fortawesome/pro-regular-svg-icons';
import { faTags, faLaptopMobile } from '@fortawesome/pro-duotone-svg-icons';
import { faFacebook, faTwitter, faPinterest, faInstagram } from '@fortawesome/free-brands-svg-icons';

export default function useMenuItems() {
  const { buildUrl } = useUrlGenerator();

  const socialLinks: MenuItem[] = [
    { id: 2, title: 'Twitter', href: 'https://twitter.com/discountmags', icon: faTwitter },
    { id: 3, title: 'Pinterest', href: 'https://pinterest.com/discountmags', icon: faPinterest },
    { id: 4, title: 'Instagram', href: 'https://instagram.com/discountmagsdotcom', icon: faInstagram },
  ];

  const accountLinks: MenuItem[] = [
    { id: 1, href: buildUrl('/customer?xCmd=orders'), title: 'Orders', icon: fasReceipt },
    { id: 2, href: buildUrl('/customer?xCmd=acshow'), title: 'Profile', icon: fasUserCircle },
    { id: 3, href: buildUrl('/customer?xCmd=adshow'), title: 'Addresses', icon: fasHouseChimney },
    { id: 4, href: buildUrl('/my-account/discountlock'), title: 'DiscountLock', icon: fasLock },
    { id: 5, href: buildUrl('/customer?xCmd=digitallibrary'), title: 'Digital Library', icon: fasBookOpen },
    { id: 6, href: buildUrl('/customer?xCmd=epshow'), title: 'Notifications', icon: fasBell },
  ];

  const specialDealLinks: MenuItem[] = [
    { id: 1, href: buildUrl('/categories/bundles'), title: 'Value Bundles', icon: faTags },
    { id: 2, href: buildUrl('/categories/digital/deals'), title: 'Digital Deals', icon: faLaptopMobile },
    { id: 3, href: buildUrl('/promos/postcards'), title: 'Postcards', icon: faCardsBlank },
    { id: 4, href: buildUrl('/categories/deals/under-10'), title: 'Under $10', priceIcon: { price: '10' } },
    { id: 5, href: buildUrl('/categories/deals/under-15'), title: 'Under $15', priceIcon: { price: '15' } },
    { id: 6, href: buildUrl('/categories/deals/under-20'), title: 'Under $20', priceIcon: { price: '20' } },
  ];

  return { socialLinks, accountLinks, specialDealLinks };
}
